import {type TranslationObject} from '@colonist/i18n'
import {ViewPopup} from './ViewPopup.ts'

export class ViewPopupHardwareAcceleration extends ViewPopup {
    constructor() {
        const title: TranslationObject = {key: 'strings:homePage.popups.hardwareAccelerationRequired.title'}
        const body: TranslationObject = {key: 'strings:homePage.popups.hardwareAccelerationRequired.body'}
        super(title, body, () => undefined, () => undefined, false)

        this.removeCheckButton()
        this.removeXButton()
        this.removeFooter()

        this.show()
        this.bringToFront()
    }

    private bringToFront() {
        this.container.style.zIndex = '10'
    }
}
